import { FormSetting } from '@/form-settings/form-setting';

export class UsedCostsForm extends FormSetting {
  protected static classToCall: string = 'UsedCostsForm';

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'speseLeggeDini',
            controlType: 'number',
            label: 'Spese Legge Dini',
            order: 1,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'speseOfficinaInterna',
            controlType: 'number',
            label: 'Spese Officina Interna',
            order: 2,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'speseCarrozzeria',
            controlType: 'number',
            label: 'Spese Carrozzeria',
            order: 3,
            class: 'md:w-full lg:w-4/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'speseGommista',
            controlType: 'number',
            label: 'Spese Gommista',
            order: 1,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'speseLavaggio',
            controlType: 'number',
            label: 'Spese Lavaggio',
            order: 2,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'speseGaranzia',
            controlType: 'number',
            label: 'Spese Garanzia',
            order: 3,
            class: 'md:w-full lg:w-4/12 w-full',
          },
        ],
        order: 2,
      },
    ];
  }
}
